import { CheckCircle2, Circle } from 'lucide-react'
import { evaluatePjAgradaCompleteness } from '@/utils/pjAgradaCompleteness'
import type { PjAgradaFormData } from '@/components/PjAgrada/pjAgradaTypes'
import { onlyDigits } from '@/components/PjAgrada/pjAgradaFormat'

type Props = {
  form: PjAgradaFormData
}

export function PjCadastroCompletenessChecklist({ form }: Props) {
  const result = evaluatePjAgradaCompleteness({
    nomeCompleto: form.nomeCompleto,
    email: form.email,
    telefone: form.telefone,
    cpf: onlyDigits(form.cpf) || undefined,
    cnpj: onlyDigits(form.cnpj) || undefined,
    razaoSocial: form.razaoSocial,
    cep: onlyDigits(form.cep) || undefined,
    logradouro: form.logradouro,
    numero: form.numero,
    cidade: form.cidade,
    uf: form.uf,
    bancoNome: form.bancoNome,
    bancoAgencia: form.bancoAgencia,
    bancoConta: form.bancoConta,
    bancoTipoConta: form.bancoTipoConta,
    pixChave: form.pixChave,
  })

  return (
    <div className='rounded-xl border border-[var(--glass-border)] bg-[var(--glass-bg)] p-4'>
      <div className='flex items-center justify-between gap-2 mb-3'>
        <p className='text-sm font-semibold text-[var(--text-primary)]'>Checklist do cadastro</p>
        <span className='text-xs font-bold text-[var(--text-muted)]'>{result.percent}%</span>
      </div>
      <ul className='space-y-1.5'>
        {result.fields.map((field) => (
          <li key={field.key} className='flex items-center gap-2 text-xs'>
            {field.ok ? (
              <CheckCircle2 size={14} className='shrink-0 text-emerald-600' />
            ) : (
              <Circle size={14} className='shrink-0 text-amber-600' />
            )}
            <span className={field.ok ? 'text-[var(--text-muted)]' : 'text-[var(--text-primary)]'}>
              {field.label}
            </span>
          </li>
        ))}
      </ul>
      {!result.complete && (
        <p className='mt-3 text-xs text-[var(--text-muted)] leading-relaxed'>
          Preencha os itens em aberto antes de enviar. O financeiro poderá complementar depois, se
          necessário.
        </p>
      )}
    </div>
  )
}
